"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupButton = void 0;
var PopupButton = /** @class */ (function () {
    function PopupButton(options) {
        this.init(options);
    }
    PopupButton.prototype.init = function (options) {
        var _this = this;
        var _a = options.query, query = _a === void 0 ? "[data-modal-button]" : _a, _b = options.mode, mode = _b === void 0 ? "popup" : _b;
        this.options = __assign(__assign({}, options), { mode: mode, query: query });
        this.buttons = Array.from(document.querySelectorAll(query));
        this.buttons.forEach(function (button) {
            button.addEventListener("click", function (e) {
                var currentTarget = e.currentTarget;
                if (!currentTarget)
                    return;
                _this.clickButton(currentTarget);
                if (_this.options.mode === "dialog") {
                    var dialogId = currentTarget.getAttribute("aria-controls");
                    var dialog = document.getElementById(dialogId);
                    var dialogOpenMode = _this.options.dialogOpenMode || "showModal";
                    if (dialog) {
                        if (dialog.open) {
                            dialog.close();
                        }
                        else {
                            if (dialogOpenMode === "show") {
                                dialog.show();
                            }
                            if (dialogOpenMode === "showModal") {
                                dialog.showModal();
                            }
                        }
                    }
                }
            });
        });
        this.initCloseClickOutside();
        this.initDialogClose();
    };
    PopupButton.prototype.clickButton = function (target) {
        var buttons = this.buttons;
        var isExpanded = (target === null || target === void 0 ? void 0 : target.getAttribute("aria-expanded")) === "true";
        if (this.options.mode === "popup") {
            buttons.forEach(function (button) {
                button.setAttribute("aria-expanded", "false");
            });
            target === null || target === void 0 ? void 0 : target.setAttribute("aria-expanded", String(!isExpanded));
        }
        if (this.options.mode === "dialog") {
            buttons.forEach(function (button) {
                button.setAttribute("aria-expanded", String(!isExpanded));
            });
        }
    };
    PopupButton.prototype.closeAll = function () {
        var buttons = this.buttons;
        buttons.forEach(function (button) {
            button.setAttribute("aria-expanded", "false");
        });
    };
    PopupButton.prototype.initCloseClickOutside = function () {
        document.addEventListener("click", function (e) {
            var target = e.target;
            if (!target)
                return;
            var parentElement = target.closest(this.options.query);
            var parentPrevElement = target.closest("[data-modal-button][aria-expanded=\"true\"] + *");
            if (parentElement) {
                if (parentElement.getAttribute("aria-expanded") === "true") {
                    return;
                }
            }
            if (parentPrevElement) {
                return;
            }
            this.closeAll();
        }.bind(this)); // Correctly bind 'this' to the event handler
    };
    PopupButton.prototype.initDialogClose = function () {
        var _this = this;
        if (this.options.mode !== "dialog")
            return;
        var buttons = this.buttons;
        buttons.forEach(function (button) {
            var dialogId = button.getAttribute("aria-controls");
            var dialog = document.getElementById(dialogId);
            if (dialog) {
                dialog.addEventListener("close", function () {
                    _this.closeAll();
                });
            }
        });
    };
    return PopupButton;
}());
exports.PopupButton = PopupButton;
